export default "__VITE_ASSET__2edadf70__"